export const enum TwilioQueryKeys {
  INTEGRATION_DETAILS = 'twilioIntegrationDetails',
  CUSTOMER_PROFILE = 'twilioCustomerProfile',
  BRAND = 'twilioBrand',
  CAMPAIGN = 'twilioCampaign',
  AVAILABLE_PHONE_NUMBERS = 'twilioAvailablePhoneNumbers'
}
